// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){
            const  lines = [...document.querySelectorAll('.arc-pin-line')];
            if(lines.length > 0) {
            lines.forEach(pin_line => {

              let line = pin_line.querySelector('.arc-pin-line__line');
           

              if(pin_line.classList.contains('down')) {
                tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: line,
                    start: 'center 80%',
                    scrub: false,
                    markers: false,
                  },
                });
       
                tl.to(line, {
                  height: '100%',
                  duration: 1.5,
                  ease: "power1.out"  
                });
              
              } else if(pin_line.classList.contains('small')) {
                tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: line,
                    start: 'top 80%',
                    scrub: false,
                    markers: false,
                  },
                });

                tl.to(line, {
                  width: '5%',
                  duration: 1.5,
                  ease: "power1.out"  
                });
              } else if(pin_line.classList.contains('med')) {
                tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: line,
                    start: 'top 80%',
                    scrub: false,
                    markers: false,
                  },
                });

                tl.to(line, {
                  width: '40%',
                  duration: 1.5,
                  ease: "power1.out"  
                });
              } else {
                tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: line,
                    start: 'top 80%',
                    scrub: false,
                    markers: false,
                  },
                });

                tl.to(line, {
                  width: '100%',
                  duration: 1.5,
                  ease: "power1.out"  
                });
              }
              
            

          
            });
          }

          const mediatext = [...document.querySelectorAll('.arc-image-text')];
            if(mediatext.length > 0) {
              console.log('yay');
              mediatext.forEach(media => { 

                //responsive
                let mm = gsap.matchMedia();

                mm.add("(min-width: 950px)", () => {
                  ScrollTrigger.create({
                    trigger: media,
                    pin: ".arc-text-col",
                    pinSpacing: false,
                    start: "top 10%",
                    end: "bottom bottom",
                    scrub: 1,
                  });
                });
              });
            }
            else {

            gsap.utils.toArray("section").forEach(column => {
              gsap.from(column, {
                scrollTrigger: column,
                autoAlpha: 0,
                y: 25,
                duration: 1.25,
                stagger: 0.75,
              });
            });
          }

});